export default __webpack_public_path__ + "bc544fbf0830954d3bb25d4ff8166be5.jpg";